import React from "react";

import {
  //List group
  CListGroup,
  CListGroupItem,
  //Table
  CTableDataCell,
  //Forms
  CButton
} from "@coreui/react";

const TDataAuction = (props) => {
  const [toggle, setToggle] = React.useState(false);

  const isOpen = toggle
    ? <CListGroup>
        {props.data?.map((product, i) => {
          if (i > 0) {
            return <CListGroupItem key={product.id}>{product.title}</CListGroupItem>
          }
        })}
      </CListGroup>
    : null;

  return (
    <CTableDataCell>
      {props.data &&
        props.data?.map((product, i) => {
          if (i === 0) {
            return (
              <div key={i} className="u-d-flex u-flex-row u-align-center u-justify-between">
                <span>{product.title}</span>
                <CButton color="link" onClick={() => setToggle(!toggle)}>Ver mais</CButton>
              </div>
            );
          }
        })
      }
      {props.data && isOpen}
    </CTableDataCell>
  );
}

TDataAuction.defaultProps = {};

export default TDataAuction;